var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"artist-list"},_vm._l((_vm.filteredArtists),function(artist){return _c('ArtistPod',{key:artist.name,attrs:{"artist":artist}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }